import { ENDPOINT_GET_APPLICATIONS_AND_OFFERS } from '@shared/sec-loans'
import { GetDataStep } from '@ui-common/steps/GetDataStep/GetDataStep'
import { callEndpoint } from '@ui-common/utils/http/client'
import { JSX } from 'react'
import { useIntl } from 'react-intl'
import { AnyActorRef } from 'xstate'

export const GetAllApplicationsStep = (props: { parentService: AnyActorRef; onAbort: () => unknown }): JSX.Element => {
  const intl = useIntl()

  const { parentService } = props

  return (
    <GetDataStep
      parentService={parentService}
      getDataCallback={async () => {
        const applicationsAndOffers = await callEndpoint(ENDPOINT_GET_APPLICATIONS_AND_OFFERS)
        return applicationsAndOffers
      }}
      heading={intl.formatMessage({ id: 'common-loading' })}
      onAbort={props.onAbort}
    />
  )
}
